export const skuCategoryNameToBundleTypeOrProductLine = {
  MARKETING_PLUS_SUITE: 'MARKETING_PLUS_SUITE',
  CMS_HUB_PRODUCTS: 'CMS',
  COMMERCE_PRODUCTS: 'COMMERCE',
  OPERATIONS_HUB_PRODUCTS: 'OPERATIONS',
  SERVICE_HUB_PRODUCTS: 'SERVICE',
  SALES_PRODUCTS: 'SALES',
  MARKETING_PRODUCTS: 'MARKETING',
  CRM_SUITE: 'CRM_SUITE'
};
export const skuCategoryNameToProductLine = {
  CMS_HUB_PRODUCTS: 'CMS',
  COMMERCE_PRODUCTS: 'COMMERCE',
  OPERATIONS_HUB_PRODUCTS: 'OPERATIONS',
  SERVICE_HUB_PRODUCTS: 'SERVICE',
  SALES_PRODUCTS: 'SALES',
  MARKETING_PRODUCTS: 'MARKETING'
};
export const bundleTypeToSkuCategoryName = {
  MARKETING_PLUS_SUITE: 'MARKETING_PLUS_SUITE',
  CRM_SUITE: 'CRM_SUITE',
  NONE: 'OTHER'
};
export const productLineToSkuCategoryName = {
  SALES: 'SALES_PRODUCTS',
  SERVICE: 'SERVICE_HUB_PRODUCTS',
  CMS: 'CMS_HUB_PRODUCTS',
  OPERATIONS: 'OPERATIONS_HUB_PRODUCTS',
  MARKETING: 'MARKETING_PRODUCTS',
  COMMERCE: 'COMMERCE_PRODUCTS'
};